import React from "react";
import { getShortDate } from "./placeUtils";

function Review(props) {
  return (
    <div className="review">
      <p>
        <span className="user-avatar">
          <img src={process.env.PUBLIC_URL + "/icons/user.png"} alt="" />
        </span>
        {props.item.author === undefined || props.item.author === "" ? "recenzent wolne.info" : props.item.author}
      </p>
      <hr></hr>
      <p>{props.item.content}</p>
      <div className="comment-date">
        <p>Dodano: {getShortDate(props.item.date)}</p>
      </div>
    </div>
  );
}

export default Review;
